import { QUESTION_IDS } from 'bundles/onboarding-common/constants/questionScheme';
import useUpdateDesiredSkillsOrUnsure from 'bundles/onboarding-common/hooks/useUpdateDesiredSkillsOrUnsure';
import useUpdateInterestedDomains from 'bundles/onboarding-common/hooks/useUpdateInterestedDomains';
import useUpdateLearnerOccupationPreferencesOrUnsure from 'bundles/onboarding-common/hooks/useUpdateLearnerOccupationPreferencesOrUnsure';
import useUpdateUserProfile from 'bundles/onboarding-common/hooks/useUpdateUserProfile';
import type { QuestionValue } from 'bundles/onboarding-common/types';

const useGetLearnerObjectPromise = () => {
  const { updateUserProfile } = useUpdateUserProfile();
  const { updateLearnerOccupationPreferencesOrUnsure } = useUpdateLearnerOccupationPreferencesOrUnsure();
  const { updateDesiredSkillsOrUnsure } = useUpdateDesiredSkillsOrUnsure();
  const { updateInterestedDomains } = useUpdateInterestedDomains();

  const getLearnerObjectPromise = async ({
    questionValue,
    userId,
    externalId,
  }: {
    questionValue: QuestionValue | null | undefined;
    userId?: number;
    externalId?: string;
  }) => {
    switch (questionValue?.__typename) {
      case QUESTION_IDS.learningGoal:
        return updateUserProfile({ learningGoal: questionValue.value || undefined, userId, externalId });
      case QUESTION_IDS.roleSelect:
      case QUESTION_IDS.roleSelectAdvancer:
        return updateLearnerOccupationPreferencesOrUnsure(questionValue.value);
      case QUESTION_IDS.skillSelect:
        return updateDesiredSkillsOrUnsure(questionValue.value);
      case QUESTION_IDS.jobTitle:
        return updateUserProfile({ currentOccupation: questionValue.value || undefined, userId, externalId });
      case QUESTION_IDS.educationLevel:
        return updateUserProfile({ educationLevel: questionValue.value || undefined, userId, externalId });
      case QUESTION_IDS.domainSelect:
        return updateInterestedDomains({ domains: questionValue.value });
      default:
        return Promise.resolve();
    }
  };

  return { getLearnerObjectPromise };
};

export default useGetLearnerObjectPromise;
